"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regexps = void 0;
exports.regexps = {
    // 手机号码输入校验规则
    inputtingMobile: '^([0-9]{0,3})\\s?([0-9]{0,4})\\s?([0-9]{0,4})$',
    // 大陆手机号码校验
    chnMobile: '^\\+?((00[- ]?)?(86[- ]?)?)?1[3|4|5|6|7|8|9]\\d{9}$',
    // 港澳手机号码
    hkmoMobile: '^\\+?((00[- ]?)?(85[2|3][- ]?)?)?[4|5|6|7|8|9]\\d{7}$',
    // 台湾手机号码
    twMobile: '^\\+?((00[- ]?)?(886[- ]?)?)?([0]?9\\d{8})$',
    // 大陆固话校验
    chnLandline: '^\\+?((00[- ]?)?(886[- ]?)?)?(010|02\\d|0[3-9]\\d{2,3})[- ]?\\d{7,8}$',
    // 大陆固话校验 - 区号可不填
    chnLandlineNew: '^\\+?((00[- ]?)?(886[- ]?)?)?((010|02\\d|0[3-9]\\d{2,3})[- ]?)?\\d{7,8}$',
    // 港澳固话校验
    hkmoLandline: '^\\+?((00[- ]?)?(85[2|3][- ]?)?)?[2|3]\\d{7}$',
    // 台湾固话校验
    twLandline: '^[A-Za-z\\d]+([-_.][A-Za-z\\d]+)*@([A-Za-z\\d]+[-.])+[A-Za-z\\d]{2,5}$',
    // 大陆固话400校验
    chnLandlineShare: '^(400)[- ]?\\d{4}([- ]?\\d{1,6})?([-]?\\d{1,8})?$',
    // 邮箱校验
    mail: '^[A-Za-z\\d]+([-_.][A-Za-z\\d]+)*@([A-Za-z\\d]+[-.])+[A-Za-z\\d]{2,5}$',
    // 手机号，400电话格式验证，座机号，固定电话校验规则
    phone: '^(((((010)|(02[0-9])|(0[3-9]\\d{2}))-?)?[2-9][0-9]{6,7}(-[0-9]{1,6})?)|(((400)-?)?[2-9][0-9]{2}-?\\d{4}(-[0-9]{1,6})?)|((\\+?86)?[1][3-9][0-9]{9}))$',
    // 各渠道非电话号码校验
    notPhone: '^((((\\+?00[- ]?86[- ]?)|(\\+?86[- ]?))?(010|02\\d|0[3-9]\\d{2,3})[- ]?\\d{7,8}([-]\\d{1,8})?)|(((400)[- ]?)\\d{4}([- ]?\\d{1,6})?([-]\\d{1,8})?))$'
};
exports.default = {
    name: 'utils-regexps',
    install: function (UIP) {
        UIP.checkModule('utils', 'regexps');
        UIP.utils.regexps = exports.regexps;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/utils-regexps/dist/index.js
// module id = 5wQv
// module chunks = 1